<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
  }),
  created() {
    let token = localStorage.getItem("token");
    if (token && this.$route.name != "Home") this.$router.push({ name: "Home" });
    else if (!token && this.$route.name != "Login") this.$router.push({ name: "Login" });
  },
};
</script>

<style></style>
